import {
  ArrowRightIcon,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  InfoCardList,
  useRouter,
} from '@forgeglobal/design-framework'
import { LinkTo, transformHoldingFragment } from 'components/holdings/HoldingUtils'
import { useAccountHoldingsQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

const LatestHoldings: React.FC<{ openSidebar: () => void }> = ({ openSidebar }) => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useAccountHoldingsQuery({ variables: { accountId: match.params.id } })
  const holdings = data?.account?.holdings ?? []
  const dataList = holdings.map(holding => transformHoldingFragment(holding, false, LinkTo.Issuer))
  return (
    <Card>
      <CardHeader
        title="Latest Holdings"
        action={
          <IconButton onClick={openSidebar}>
            <ArrowRightIcon />
          </IconButton>
        }
      />
      <CardContent>
        <InfoCardList items={dataList} />
      </CardContent>
    </Card>
  )
}

export { LatestHoldings }
